// generated from 316 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedWhatsAppCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_whats_app_campaign_filter"),
  comparison_key: z.enum([
    "6", // 271 (85.76%)
    "4", // 18 (5.70%)
    "12", // 14 (4.43%)
    "3", // 11 (3.48%)
    "5", // 2 (0.63%)
  ]),
  display_name: z.string(),
  // undefined: 38 (12.03%), defined 278 (87.97%)
  raw_value: z
    .union([
      // number samples: 262 (94.24%)
      // integer: 259 (98.85%)
      // avg: 5.15, min: 0.041666666666666664, max: 30
      z.number().nonnegative(),
      // string samples: 16 (5.76%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 289 (91.46%)
    // integer: 282 (97.58%)
    // avg: 5.09, min: 0.041666666666666664, max: 30
    z.number().nonnegative(),
    // string samples: 27 (8.54%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
